import Text from "@shared/components/Text";

export default Text;
